import InstallAppButton from './install-app-button';

export default InstallAppButton;
